module.exports = __webpack_public_path__ + "static/media/check-circle-07.1973ac8b.svg";